"use client";
/*
 * Documentation:
 * DC_Card_Sticky — https://app.subframe.com/4f62853ee923/library?component=DC_Card_Sticky_dc35b5d7-dace-455b-b9bd-51724ddf94f4
 */

import React from "react";
import { FeatherCpu } from "@subframe/core";
import * as SubframeCore from "@subframe/core";
import * as SubframeUtils from "../utils";

interface Dc_Card_StickyRootProps extends React.HTMLAttributes<HTMLDivElement> {
  changeImagePos?: boolean;
  image?: string;
  icon?: React.ReactNode;
  headline?: React.ReactNode;
  subhead?: React.ReactNode;
  text?: React.ReactNode;
  imageSlot?: React.ReactNode;
  isPrint?: boolean;
  className?: string;
}

const Dc_Card_StickyRoot = React.forwardRef<
  HTMLDivElement,
  Dc_Card_StickyRootProps
>(function Dc_Card_StickyRoot(
  {
    changeImagePos = false,
    image,
    icon = <FeatherCpu />,
    headline,
    subhead,
    text,
    imageSlot,
    isPrint = false,
    className,
    ...otherProps
  }: Dc_Card_StickyRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "group/dc35b5d7 flex flex-col items-center gap-6 rounded-md bg-neutral-50 px-12 py-12",
        { "px-6 py-6": isPrint },
        className
      )}
      ref={ref}
      {...otherProps}
    >
      <div
        className={SubframeUtils.twClassNames(
          "flex grow shrink-0 basis-0 items-center gap-12",
          {
            "flex-row flex-nowrap gap-6": isPrint,
            "flex-row-reverse": changeImagePos,
          }
        )}
      >
        {imageSlot ? (
          <div className="flex grow shrink-0 basis-0 items-center gap-2 overflow-hidden rounded-md">
            {imageSlot}
          </div>
        ) : null}
        <div className="flex grow shrink-0 basis-0 flex-col items-start gap-6">
          {icon ? (
            <SubframeCore.IconWrapper className="text-heading-3 font-heading-3 text-default-font">
              {icon}
            </SubframeCore.IconWrapper>
          ) : null}
          {headline ? (
            <span className="w-full text-heading-3 font-heading-3 text-default-font">
              {headline}
            </span>
          ) : null}
          {subhead ? (
            <span className="w-full text-body-bold font-body-bold text-default-font">
              {subhead}
            </span>
          ) : null}
          {text ? (
            <span className="w-full text-body font-body text-default-font">
              {text}
            </span>
          ) : null}
        </div>
      </div>
    </div>
  );
});

export const Dc_Card_Sticky = Dc_Card_StickyRoot;
